import React, { useContext } from 'react';

import useApi from 'common/useApi';
import UiContext from 'common/UiContext/UiContext';

import InfoText from 'components/InfoText';
import Loading from 'components/Loading';

import IDashboardData from 'pages/Dashboard/IDashboardData';

const ConnectWorkers = ({ close }: { close(): void }) => {
  const { addToast } = useContext(UiContext);
  // Same source as the dashboard's Pool Information (env-driven EXA_STRATUM_URL
  // + the subaccount's stratum credentials), so the two never disagree.
  const { isLoading, data, isError } = useApi('get', '/api/dashboard/totals');
  const pool = data as IDashboardData | undefined;

  if(isError) {
    addToast!('Error loading pool information', 'Error');
    close();
    return null;
  }

  return (
    <>
      {isLoading ? <Loading /> : (
        <>
          <p>
      Point your mining device at one of the stratum URLs below. They all reach
      the same pool — use whichever gives you the most stable connection and
      lowest latency.
          </p>
          <InfoText
            content={[`#1 ${pool?.stratum_url_1}`]}
            title='Configure your mining device'
            copyable={true}
          />
          <InfoText
            content={[`#2 ${pool?.stratum_url_2}`]}
            copyable={true}
          />
          <InfoText
            content={[`#3 ${pool?.stratum_url_3}`]}
            copyable={true}
          />
          <InfoText
            content={[`userID:	${pool?.pool_user}`, `password:	${pool?.pool_pass}`]}
            copyable={true}
          />
          <p>
      Note: workerName is optional — it is fine if you do not provide any.
      In this case, our system will automatically create an auto worker for you.
      However, we recommend connecting each mining device with a separate workerName for efficient monitoring.
          </p>
          <p>
      Please be patient. It may take a few minutes for your newly connected device to show up.
          </p>
          <button className='primary big' onClick={() => {
            close();
          }}>Connected! Go back</button>
        </>
      )}
    </>
  );
};

export default ConnectWorkers;
